import {
  ADMINDRAWER_OPEN,
  ADMINDRAWER_CLOSE,
  APP_DRAWER_TOGGLE
} from "types/actions/drawers"

export const openAdminDrawer = data => ({
  type: ADMINDRAWER_OPEN,
  ...data,
  adminDrawer: true
})

export const closeAdminDrawer = data => ({
  type: ADMINDRAWER_CLOSE,
  adminDrawer: false
})

export const toggleDrawer = () => ({
  type: APP_DRAWER_TOGGLE
})



// WEBPACK FOOTER //
// ./src/actions/drawers.js